import React, { useEffect, useState } from "react";
import { ReactComponent as SkalebotLogo } from "../../assets/svgIcons/Skalebot.svg";
import styles from "./style.module.css";

const Header = ({ logoUrl }) => {
  return (
   <div className={`w-full px-6 ${styles.header}`}>
  <div
    style={{
      height: "60px",
      width: "100px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    {logoUrl ? (
      <img
        className="logo_image_container"
        src={logoUrl}
        alt="Company Logo"
        style={{
          maxHeight: "100%",
          maxWidth: "100%",
          objectFit: "contain",
        }}
      />
    ) : (
      <SkalebotLogo
        className={`${styles["logo-css"]} cursor-pointer`}
        style={{
          maxHeight: "100%",
          maxWidth: "100%",
          objectFit: "contain",
        }}
      />
    )}
  </div>

  <span
    style={{
      marginLeft: "5px",
      marginTop: "3px",
      fontSize: "0.7rem",
      marginRight: "5px",
      color: "#fff",
    }}
  >
    Pro
  </span>
</div>

  );
};

export default Header;
